const operator = {
	EQUALTO: 'EqualTo',
	NOTEQUALTO: 'NotEqualTo',
	PREFIX: 'Prefix',
	GREATERTHAN: 'GreaterThan',
	GREATERTHANEQUALTO: 'GreaterThanEqualTo',
	LESSTHAN: 'LessThan',
	LESSTHANEQUALTO: 'LessThanEqualTo'
};

const condition = (op, values) => {
	return {
		operator: op,
		values
	};
};

const argument = (field, conditions) => {
	return {
		field,
		conditions
	};
};

const getDefaultInputs = {
	argsOperator: 'AND',
	sortArguments: [{ direction: 'desc', field: 'DocumentDate' }]
};

export {
	operator,
	condition,
	getDefaultInputs,
	argument
};
